import { render, staticRenderFns } from "./BuyPassReview.vue?vue&type=template&id=6459002a&scoped=true&"
import script from "./BuyPassReview.vue?vue&type=script&lang=js&"
export * from "./BuyPassReview.vue?vue&type=script&lang=js&"
import style0 from "./BuyPassReview.vue?vue&type=style&index=0&id=6459002a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6459002a",
  null
  
)

export default component.exports